import React, { useContext, useState } from 'react'

import { FetchState, TicketRight } from '../../../api-clients/api-types'
import { useEmployee } from '../../../contexts/employee-context'
import { useUpdateManualOrder } from '../../../hooks/use-manual-order'
import { ChangeTicketRightModal } from '../change-ticket-right-modal'
import TicketTypeCategoryDropdown, {
  getSelectedUpdateTypeByValue,
  ticketTypeCategoryFormField,
  ticketTypeToDropdownItemType,
  UpdateTypes,
} from '../../form/ticket-type-category-dropdown'
import { CardActionChip, TicketRightCardBase } from './ticket-right-card-base'
import { RuleElement } from '../rule-element'
import { useClientInfo } from '../../../contexts/client-info-context'
import { ReadOnlyContext } from '../../../contexts/read-only-context'

type TraineeTicketRightCardProps = {
  ticketRight: TicketRight
}
export const TraineeTicketRightCard: React.FC<TraineeTicketRightCardProps> = ({ ticketRight }) => {
  const { hasSensitiveAccess } = useClientInfo()
  const { readOnly } = useContext(ReadOnlyContext)
  const { employee } = useEmployee()
  const { updateManualOrderResponse, updateManualOrder, fetchUpdatedEmployeeResponse } = useUpdateManualOrder(() =>
    setOpenBlueModal(false)
  )
  const [validationError, setValidationError] = useState<string>()
  const [selected, setSelected] = useState(
    ticketTypeCategoryFormField(ticketTypeToDropdownItemType(ticketRight.ticketType).value)
  )
  const [isOpenBlueModal, setOpenBlueModal] = useState<boolean>(false)
  const categoryName = ticketRight.manualOrder?.ticketType?.description?.split(',')[1]?.trim() || 'Ikke valgt'

  const isLoading =
    updateManualOrderResponse.status === FetchState.LOADING &&
    fetchUpdatedEmployeeResponse.status === FetchState.LOADING
  let error
  if (
    updateManualOrderResponse.status === FetchState.ERROR &&
    updateManualOrderResponse.error instanceof Error &&
    updateManualOrderResponse.error.message !== 'Not Found'
  )
    error = 'Rettigheten ble ikke endret'
  if (fetchUpdatedEmployeeResponse.status === FetchState.ERROR)
    error = 'Henting av endret rettighet feilet, last siden på nytt'
  if (validationError) error = validationError

  const selectCategory = (
    <ChangeTicketRightModal
      title="Endre rettighetstype"
      onSubmit={() => {
        if (ticketRight.manualOrder?.id !== undefined) {
          const update = getSelectedUpdateTypeByValue(selected.value)
          if (update.type === UpdateTypes.TICKET_TYPE_APPRENTICE) {
            const ticketTypeId = parseInt(update.value, 10)
            if (ticketTypeId !== ticketRight.ticketType.id) {
              updateManualOrder({
                id: ticketRight.manualOrder?.id || 0,
                ticketTypeId,
              })
              setValidationError(undefined)
            } else {
              setValidationError('Ingen endring i rettighetstype')
            }
          } else {
            setValidationError('Vennligst velg en rettighetstype')
          }
        }
      }}
      isOpen={isOpenBlueModal}
      setOpen={setOpenBlueModal}
      isLoading={isLoading}
      errorMessage={error}
    >
      <TicketTypeCategoryDropdown
        formField={selected}
        company={employee.company}
        update={setSelected}
        ticketType="trainee"
      />
    </ChangeTicketRightModal>
  )

  const actionChips =
    !readOnly && hasSensitiveAccess === true ? (
      <>
        <CardActionChip onClick={() => setOpenBlueModal(true)}>Endre kategori</CardActionChip>
        {isOpenBlueModal && selectCategory}
      </>
    ) : undefined
  return (
    <TicketRightCardBase ticketRight={ticketRight} categoryName={categoryName} actionChips={actionChips}>
      <RuleElement createdByRule={ticketRight?.createdByRule} />
    </TicketRightCardBase>
  )
}
